export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-50 rounded-lg p-6 md:p-10">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">移动阅读</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              随时随地畅享<strong>韩国漫画在线看</strong>体验。无论是通勤路上还是睡前时光，
              打开手机即可阅读精选的<strong>好看的韩国漫画大全</strong>，纵向滚动阅读完美适配移动端屏幕。
              轻点收藏，随时回顾你的<strong>韩国漫画高分推荐</strong>列表，不错过任何一部必看佳作。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-5">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-md bg-foreground-900 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                <i className="ri-smartphone-line text-lg"></i>
                立即体验
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多特色
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[460px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20Korean%20manhwa%20webtoon%20reader%20app%20interface%20on%20screen%2C%20showing%20a%20beautiful%20romance%20comic%20panel%20with%20characters%2C%20clean%20modern%20app%20design%2C%20warm%20coral%20and%20cream%20background%2C%20vertical%20scroll%20layout%2C%20soft%20lighting%2C%20product%20photography%20style&width=520&height=920&seq=app-mockup-01&orientation=portrait"
                alt="韩国漫画 - 移动端在线阅读体验"
                title="韩国漫画在线看 | 移动阅读"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}